import { initContract } from '@ts-rest/core';
import { z } from 'zod';
import { ZPlayerAccountSelectPrivate } from '../payment/models';
import {
  ZChangePassword,
  ZPlayerSelectPrivateWithHasSocialLogin,
  ZPlayerUpdate,
} from './models';
import { ZodValidationErrorResponse } from '@daymade/common-lib/zodTypes';

const c = initContract();
export const authPlayerContract = c.router(
  {
    getDetails: {
      method: 'GET',
      path: '/details',
      responses: {
        200: z.object({
          player: ZPlayerSelectPrivateWithHasSocialLogin,
          balances: ZPlayerAccountSelectPrivate,
          isFtmp: z.boolean(),
        }),
        404: c.type<{ message: 'Not Found'; reason: string }>(),
      },
      summary: 'Get player details contract',
    },

    updateDetails: {
      method: 'POST',
      path: '/details',
      body: z.object({
        player: ZPlayerUpdate,
      }),
      responses: {
        200: z.object({
          player: ZPlayerSelectPrivateWithHasSocialLogin,
        }),
        400: z.union([
          z.object({
            message: z.literal('Bad Request'),
            reason: z.literal('EMAIL_ADDRESS_IN_USE'),
          }),
          ZodValidationErrorResponse,
        ]),
      },
      summary:
        'Update player details for the player specified in the access token',
    },

    setAbTestGroup: {
      method: 'POST',
      path: '/abTestGroup',
      body: z.object({
        testName: z.string(),
        testValue: z.string(),
      }),
      responses: {
        200: z.object({
          success: z.literal(true),
        }),
        401: z.object({
          message: z.string().optional(),
        }),
      },
      summary:
        'Update player details for the player specified in the access token',
    },

    changePassword: {
      method: 'POST',
      path: '/change-password',
      body: ZChangePassword,
      responses: {
        200: z.object({
          token: z.string(),
        }),
        400: c.type<{
          message: 'Bad Request';
          reason:
            | 'INCORRECT_CURRENT_PASSWORD'
            | 'NO_EXISTING_PASSWORD'
            | 'USER_NOT_FOUND'
            | 'INVALID_PASSWORD';
        }>(),
      },
      summary: 'Update password for the player specified in the access token',
    },

    uploadAvatarIcon: {
      method: 'POST',
      path: '/upload-avatar-icon',
      contentType: 'multipart/form-data',
      body: c.type<{ image: File }>(),
      responses: {
        200: z.string(),
        400: c.type<{ message: string }>(),
      },
    },
  },
  {
    pathPrefix: '/auth',
    baseHeaders: z.object({
      'x-access-token': z.string(),
    }),
    commonResponses: {
      401: c.type<{ message: 'Unauthorized'; statusCode: 401 }>(),
      // 500: c.otherResponse({
      //   contentType: 'text/plain',
      //   body: z.literal('Server Error'),
      // }),
    },
  },
);
